import { ToLocaleDateBaseValueConverter } from 'General/Resources/ValueConverters/ToLocaleDateBase';
export class ToLocaleDateValueConverter extends ToLocaleDateBaseValueConverter {

}